// extracted by mini-css-extract-plugin
module.exports = {"container":"album-module--container--3jk8H","image":"album-module--image--2Mnz5"};